import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Login from "../Pages/Auth/Login";
import Dashboard from "../Pages/Dashboard/Dashboard";
import ForgotPassword from "../Pages/Auth/ForgotPassword";
import ResetPassword from "../Pages/Auth/ResetPassword";
import Splash from "../Pages/Auth/Splash";
import Register from "../Pages/Auth/Register";
import TwoFactorSetup from "../Pages/Auth/TwoFactorSetup";
import ForceChangePassword from "../Pages/Auth/ForceChangePassword";
import Settings from "../Pages/Settings/Settings";
import PublicRoute from "../utils/services/PublicRoute";
import PrivateRoute from "../utils/services/PrivateRoute";
import { useDispatch } from "react-redux";
import { setFunctions } from "../utils/config/config";

const AppRouter = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    setFunctions(dispatch);
  }, [dispatch]);

  return (
    <BrowserRouter basename="/dashboard">
      <Routes>
        <Route element={<PublicRoute />}>
          <Route path="/" element={<Splash />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/home" element={<Dashboard />} />
          <Route path="/setup-2fa" element={<TwoFactorSetup />} />
          <Route path="/change-password" element={<ForceChangePassword />} />
          <Route path="/settings" element={<Settings />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;
